import React, { useState } from 'react';

import { Box, Button, Collapse, makeStyles, Typography } from '@material-ui/core';
import ArrowDown from '@material-ui/icons/ArrowDownward';
import ArrowUp from '@material-ui/icons/ArrowUpward';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import { GameImagesProps } from '../Images/GameImages';
import { SpecificationsProps } from '../Specifications/Specifications';

const Specifications = dynamic(import('../Specifications/Specifications'));
const Images = dynamic(import('../Images/GameImages'));

export interface AboutGameProps {
  title: string;
  description?: string;
  specifications: SpecificationsProps['items'];
  images: GameImagesProps['items'];
}

const useStyles = makeStyles(theme => ({
  collapse: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

const AboutGame = ({ title, description, specifications, images }: AboutGameProps) => {
  const classes = useStyles();

  const [isOpen, setOpen] = useState(false);

  const handleReadMoreClick = () => {
    setOpen(!isOpen);
  };

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="body1" color="textPrimary">
        {title}
      </Typography>
      <Collapse className={classes.collapse} in={isOpen} collapsedSize={60}>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Collapse>
      {description && description.length > 130 && (
        <Box display="flex" mb={4}>
          <Button
            variant="text"
            color="primary"
            onClick={handleReadMoreClick}
            endIcon={isOpen ? <ArrowUp /> : <ArrowDown />}
          >
            <FormattedMessage
              id={isOpen ? 'general.actions.read_less' : 'general.actions.read_more'}
            />
          </Button>
        </Box>
      )}
      {images.length > 0 && <Images items={images} />}
      <Box mt={!!images.length ? 10 : 0}>
        {specifications.length > 0 && <Specifications items={specifications} />}
      </Box>
    </Box>
  );
};

export default AboutGame;
